import React, { ComponentPropsWithoutRef, useEffect, useState } from "react"

import Vector2 from "../../utils/baseClasses/Vector2"

import type { ParticleEffect } from "./ParticleEffectContext"
import type { ElementExplosionAnimationProps } from "../liveUserStats/ElementExplosionAnimation"

interface ParticleEffectWrapperProps extends ComponentPropsWithoutRef<"div"> {
  anchorElement: Element
  positionOffset: Vector2
}

const ParticleEffectWrapper: React.FC<ParticleEffectWrapperProps> = ({
  anchorElement,
  positionOffset,

  children,
}) => {
  const [viewportOffset, setViewportOffset] = useState<DOMRect>(null)

  useEffect(() => {
    if (anchorElement) {
      setViewportOffset(anchorElement.getBoundingClientRect())
    }
  }, [anchorElement])

  return viewportOffset && (
    <div
      style={{
        position: "absolute",
        left: (viewportOffset.left + (viewportOffset.width * positionOffset.x / 100)) + "px",
        top: (viewportOffset.top + (viewportOffset.height * positionOffset.y / 100)) + "px",
      }}
    >
      {children}
    </div>
  )
}

export default ParticleEffectWrapper
